import useUserSettings from "@/lib/queries/user/useUserSettings";
import ProfileSettings from "@/components/ProfileSettings";
import Loading from "@/components/Loading";
import { useId } from "react";
import { useStytchSession } from "@stytch/react";

function Settings() {
  const { session, fromCache } = useStytchSession();
  const { useGetUserSettings: useGetUser } = useUserSettings();

  const {
    data,
    isLoading,
    isError,
    error: _error,
  } = useGetUser({
    enabled: !!session && !fromCache,
  });
  const formId = useId();
  if (isLoading || !data) {
    if (isError) {
      throw new Error("Failed to load user settings");
    }
    return <Loading />;
  }

  return (
    <ProfileSettings
      data={{
        firstName: data.firstName,
        middleName: data.middleName ? data.middleName : "",
        lastName: data.lastName,
        school: data.school ? data.school : "",
        language: data.language,
        pilot: data.pilot,
        pilotEmail: data.pilotEmail,
        preferences: data.preferences,
        displayLanguage: data.displayLanguage,
        resultLanguage: data.resultLanguage,
      }}
      key={formId}
    />
  );
}

export default Settings;
